import ParseService from '~/services/parseService';
import Backbone from 'backbone';
import EventHub from '~/eventHub';
import Model from '~/models/parseModel';
import Collection from '~/collections/parseCollection';
import Settings from '~/settings.js';
import toastr from 'toastr';

/**
 * Assigns _User class with properties
 * @member [_User] UserModel
 */
var UserModel = Model.extend({
  className: "_User",
});

/**
 * Represents a collection of users
 * @member [User collection] UserCollection
 */
var UserCollection = Collection.extend({
  model: UserModel,
});

/**
 * @member [User Class] UserService
 */
var UserService = ParseService.extend({
    /**
     * @member [string] sortBy
     */
    sortBy: 'createdAt',
    /**
     * @member [number] itemsOnPage
     */
    itemsOnPage: 100,
    /**
     * @member [userModel] model
     */
    model: UserModel,
    /**
     * @member [userCollection] collection
     */
    collection: UserCollection,
    /**
     * @member [array] role_buffer
     */
    role_buffer: [],

    /**
     * verify that users are valid
     * @function isAuthorized
     * @returns [user]
     * @memberOf ParseService.extend
     */
    isAuthorized: function () {
        return Parse.User.current();
    },
    /**
     * this is loging function
     * @function authorize
     * @param login
     * @param pwd
     * @memberOf ParseService.extend
     */
    authorize: function (login, pwd, token) {
        return Parse.User.logIn(login, pwd, {token: token}).then(() => {});
    },
    // generate cache key
    //generateCacheKey: function (settings) {
    // here is the most simple cache were we always returns the same collection (sure for specific service only)
    // for some services we can implement complex logic (for example with some merge logic or by userid)
    //return 'data-' + settings.id + '-name';
    //},
    /**
     * logout function
     * @function logOut
     * @memberOf ParseService.extend
     */
    logOut: function () {
  		var unLoggedView = false;
  		if(Parse.User.current().attributes.newUser == true){
  			unLoggedView = true;
  		}
        if(Settings.req2fa && !Parse.User.current().attributes.enabled2fa){
  			unLoggedView = true;
  		}
  		if(window.localStorage.pushInfo && window.localStorage.pushInfo != ''){
  			var data = {
  				pushInfo: JSON.parse(window.localStorage.pushInfo)
  			};
  			Parse.Cloud.run("unsuscribeWebPushUser", data).then(() => {
  				Parse.User.logOut().then(() => {
                    window.localStorage.pushInfo = '';
  					EventHub.trigger('logout');
  					if(!unLoggedView){
  						Backbone.history.loadUrl('/login?reset');
  					}
  				},
  				(error) => {
  					console.log(error);
  					switch(error.code){
  						case 100:
  							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
  						break;
  					}
  				});
  			},
  			(error) => {
  				console.log(error);
  				switch(error.code){
  					case 100:
  						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
  					break;
  				}
  			});
  		}
  		else{
  			Parse.User.logOut().then(() => {
                window.localStorage.pushInfo = '';
  				EventHub.trigger('logout');
  				if(!unLoggedView){
  					Backbone.history.loadUrl('/login?reset');
  				}
  			},
  			(error) => {
  				console.log(error);
  				switch(error.code){
  					case 100:
  						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
  					break;
  				}
  			});
  		}
    },

    /**
     * this function returns the nicely formatted user name.
     * @function getUserNiceName
     * @returns {string}
     * @memberOf ParseService.extend
     * @returns {string[]}
     */
    getUserNiceName: function () {
        // this function returns the nicely formatted user name.

        /**
         * @member [string] firstName
         */
        var firstName = Parse.User.current().attributes.firstName;
        /**
         * @member [string] lastName
         */
        var lastName = Parse.User.current().attributes.lastName;
        /**
         * @member [string] nickname
         */
        var nickname = Parse.User.current().attributes.nickname;
        /**
         * @member [string] email
         */
        var email = Parse.User.current().attributes.email;
        /**
         * @member [string] userFormattedName
         */
        var userFormattedName = '';
        /**
         * @member [boolean] hasFirstName
         */
        var hasFirstName = false;
        /**
         * @member [boolean] hasLastName
         */
        var hasLastName = false;
        /**
         * @member [boolean] hasNickName
         */
        var hasNickName = false;
        //validations
        if (firstName) {
            hasFirstName = true;
        }
        if (lastName) {
            hasLastName = true;
        }
        if (nickname) {
            hasNickName = true;
        }
        if (hasFirstName) {
            if (hasLastName) {
                // has both
                userFormattedName = firstName + " " + lastName;
            } else {
                //has only first firstName
                if (hasNickName) {
                    userFormattedName = firstName + " (" + nickname + ")";
                } else {
                    // has no nickname.
                    userFormattedName = firstName;
                }
            }
        } else {
            // has NO firstname
            if (hasLastName) {
                // Has lastname, but no firstname
                if (hasNickName) {
                    // has lastname + nickname
                    userFormattedName = lastName + " (" + nickname + ")";
                } else {
                    // has only lastname
                    userFormattedName = lastName;
                }
            } else {
                // has NO lastname either
                if (hasNickName) {
                    // has ONLY nickname
                    userFormattedName = nickname;
                } else {
                    // has NOTHING!
                    userFormattedName = email;
                }
            }
        }


        return userFormattedName;
    },
    /**
     * gets workers user list
     * @function getWorkers
     * @memberOf ParseService.extend
     * @returns {Promise.<TResult>}
     */
    getWorkers: function () {
        var collection = this;
        return Parse.Promise.as().then(function () {
            var query = new Parse.Query(Parse.Role);
            query.equalTo("name", "funcionario");
            return query.first();
        }).then(function (role) {
            var query = role.relation('users').query();
            return query.find();
        }).then(function (users) {
            return users;
        });
    },
    /**
     * gets user list roles
     * @function getRoleUsers
     * @param role_list
     * @memberOf ParseService.extend
     * @returns {Promise.<TResult>}
     */
    getRoleUsers: function (role_list) {
        return Parse.Promise.as().then(function () {
            var query = new Parse.Query(Parse.Role);
            query.containedIn("name", role_list);
            return query.find();
        }).then(function (roles) {
            var queries = [];
            for (var i = 0; i < roles.length; i++) {
                queries.push(roles[i].relation("users").query().find());
            }
            return queries;
        }).then(function (queries) {
            var _this = this;
            var users_list = [];
            for (var i = 0; i < queries.length; i++) {
                queries[i].then(function (users) {
                    users_list.push(users);
                });
            }
            return users_list;
        });
    },

    isSessionInvalid: function() {
      return new Promise((resolve, reject) => {
        Parse.Cloud.run("CheckSession").then((res) => {
          resolve(false);
        },()=>{resolve(true);}).catch((e) => {
          console.log(e);
          if(e.code == 209){
            resolve(true);
          } else {
            reject("Server Error");
          }
        });
      });
    },

})
/**
 * @member [userService] userService
 */
var userService;
/**
 * Module userService, helps to exports a userService object
 * @module services/userService
 * @returns [userService]
 */

export default function () {
    return userService || (userService = new UserService());
};
// only created once for application
